/* eslint-disable import/no-cycle */
import { action, makeObservable, observable, runInAction } from 'mobx';
import BaseStore from './base-stores/BaseStore';
import { RootStore } from './RootStore';
import { IdentifierService, ProductOverviewCountsResponse } from '../swagger/api';

export enum FrontPageSearchEntity {
  Products = 'produkter',
  Usage = 'forbrug',
  Payment = 'betaling'
}

export enum ProductOverviewInformation {
  ActiveBizz = 'ActiveBizzes',
  InactiveBizz = 'InactiveBizzes',
  ActivePayByPlate = 'ActivePayByPlate',
  ActiveOneTimeANPR = 'ActiveOneTimeANPR',
  ActiveTollingBox = 'ActiveTollingBox',
  ActiveTollingApp = 'ActiveTollingApp'
}

export default class FrontPageStore extends BaseStore {
  searchEntity: string = FrontPageSearchEntity.Products;

  productsWithoutGreenDiscount: number = 0;

  numberOfActiveBizzesOnAccount: number = 0;

  numberOfInactiveBizzesOnAccount: number = 0;

  numberOfActiveLicensePlateProductsOnAccount: number = 0;

  numberOfActiveOneTimeANPRProductsOnAccount: number = 0;

  numberOfTollBoxesOnAccount: number = 0;

  numberOfTollAppOnAccount: number = 0;

  numberOfActiveTollBoxesOnAccount: number = 0;

  numberOfActiveTollAppsOnAccount: number = 0;

  setSearchEntity = (searchEntity: FrontPageSearchEntity) => {
    this.searchEntity = searchEntity;
  };

  getProductsWithoutGreenDiscount = () => {
    IdentifierService.getNumberOfIdentifiersNotApplicableForGreenDiscount({
      accountId: this.rootStore.userStore.currentAccount?.id!
    }).then((result: number) => {
      this.productsWithoutGreenDiscount = result;
    });
  };

  getProductOverviewInformation = () => {
    const accountId = this.rootStore.userStore.currentAccount?.id!;

    IdentifierService.getProductOverviewCounts({ accountId })
      .then((result: ProductOverviewCountsResponse) => {
        runInAction(() => {
          this.numberOfActiveBizzesOnAccount = result.activeBizzes ?? 0;
          this.numberOfInactiveBizzesOnAccount = result.inactiveBizzes ?? 0;
          this.numberOfActiveLicensePlateProductsOnAccount = result.activeLicensePlateProducts ?? 0;
          this.numberOfActiveOneTimeANPRProductsOnAccount = result.activeOneTimeAnprProducts ?? 0;
          this.numberOfTollBoxesOnAccount = result.tollBoxes ?? 0;
          this.numberOfTollAppOnAccount = result.tollApps ?? 0;
          this.numberOfActiveTollBoxesOnAccount = result.activeTollBoxes ?? 0;
          this.numberOfActiveTollAppsOnAccount = result.activeTollApps ?? 0;
        });
      })
      .catch(() => {
        runInAction(() => {
          this.numberOfActiveBizzesOnAccount = 0;
          this.numberOfInactiveBizzesOnAccount = 0;
          this.numberOfActiveLicensePlateProductsOnAccount = 0;
          this.numberOfActiveOneTimeANPRProductsOnAccount = 0;
          this.numberOfTollBoxesOnAccount = 0;
          this.numberOfTollAppOnAccount = 0;
          this.numberOfActiveTollBoxesOnAccount = 0;
          this.numberOfActiveTollAppsOnAccount = 0;
        });
      });
  };

  constructor(rootStore: RootStore) {
    super(rootStore);
    makeObservable(this, {
      searchEntity: observable,
      productsWithoutGreenDiscount: observable,
      numberOfActiveBizzesOnAccount: observable,
      numberOfInactiveBizzesOnAccount: observable,
      numberOfActiveLicensePlateProductsOnAccount: observable,
      numberOfActiveOneTimeANPRProductsOnAccount: observable,
      numberOfTollBoxesOnAccount: observable,
      numberOfTollAppOnAccount: observable,
      numberOfActiveTollBoxesOnAccount: observable,
      numberOfActiveTollAppsOnAccount: observable,
      setSearchEntity: action,
      getProductsWithoutGreenDiscount: action,
      getProductOverviewInformation: action
    });
  }
}
